import { render, staticRenderFns } from "./sendDetail.vue?vue&type=template&id=73c3c8d4&scoped=true"
import script from "./sendDetail.vue?vue&type=script&lang=js"
export * from "./sendDetail.vue?vue&type=script&lang=js"
import style0 from "./sendDetail.vue?vue&type=style&index=0&id=73c3c8d4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c3c8d4",
  null
  
)

export default component.exports